/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* ----------------------------------------------------------
     MOBILE SLIDER SCROLL FIX
     ----------------------------------------------------------
     Sleek's `.grid--mobile-slider` (Nyheter / Bestselgere /
     Kommer snart-tabs på forsiden) får bundet en mouse-drag
     handler i theme.js som kaller `preventDefault()` på
     mousedown. På iOS Safari kan dette bryte native horisontal
     touch-scroll fordi browseren tolker preventDefault som
     "JS captures this gesture".

     Fix: på touch-devices, neutraliser mouse-handlerne ved å
     stoppe events i capture-phase FØR Sleek sin handler får
     fyrt. Native overflow-x: scroll funker da som forventet.

     Påvirker bare touch-devices — desktop mouse-drag uberørt.
  ---------------------------------------------------------- */
  (function mobileSliderScrollFix() {
    if (!('ontouchstart' in window) && !navigator.maxTouchPoints) return;

    /* Capture-phase listener på slider stopper ALLE descendant-handlers
       (incl. <hover-images> som binder touchstart/touchmove med
       preventDefault for image-swap). Native overflow-x: scroll på slider
       fungerer uavhengig av JS event-listeners — så scroll funker, men
       JS-baserte gestures inni kortene er deaktivert på touch-devices.
       Click-events bubbler separat → produktlinker funker som normalt. */
    var BLOCK_EVENTS = [
      'mousedown', 'mousemove', 'mouseup', 'mouseleave', 'wheel',
      'touchstart', 'touchmove', 'touchend', 'touchcancel',
      'pointerdown', 'pointermove', 'pointerup', 'pointercancel'
    ];

    function neutralize(el) {
      if (el.dataset.mobileDragNeutralized) return;
      el.dataset.mobileDragNeutralized = '1';
      BLOCK_EVENTS.forEach(function(evt) {
        el.addEventListener(evt, function(e) {
          e.stopImmediatePropagation();
        }, { capture: true });
      });
    }

    function neutralizeAll() {
      document.querySelectorAll('.grid--mobile-slider').forEach(neutralize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', neutralizeAll);
    } else {
      neutralizeAll();
    }

    document.addEventListener('shopify:section:load', neutralizeAll);
    document.addEventListener('theme:grid-slider:init', neutralizeAll);

    // Watch for AJAX-loaded sliders (e.g. tab switches)
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('.grid--mobile-slider')) neutralize(n);
            if (n.querySelectorAll) {
              n.querySelectorAll('.grid--mobile-slider').forEach(neutralize);
            }
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  })();

  /* ----------------------------------------------------------
     KOMMER SNART — låst "Få tidlig tilgang" CTA midt på PDP-bilde
     ----------------------------------------------------------
     På "kommer snart"-produktsider (detektert via
     .badge-box--kommersnart) injiseres en CTA-knapp som ligger
     sentrert midt over produktbildet. Hele bildet får en jevn
     transparent svart overlay (ikke gradient). Knappen fader
     inn/ut når brukeren scroller gjennom bilde-området.

     Klikk åpner kundeklubb-popup'en med samme logikk som
     hero-seksjonens CTA bruker (matcher behavior eksakt).
  ---------------------------------------------------------- */
  (function kommerSnartStickyCTA() {
    function getKKPopup() {
      return Array.from(document.querySelectorAll('*')).find(function(el) {
        return el.tagName && el.tagName.toLowerCase().indexOf('kundeklubb-popup-') === 0;
      });
    }

    function openKKPopup(trigger) {
      var kk = getKKPopup();
      if (!kk) return false;
      var ctaText = trigger.textContent.trim();
      trigger.setAttribute('data-kk-open', '');
      trigger.setAttribute('data-kk-title', ctaText);
      trigger.setAttribute('data-kk-button', 'FORTSETT');
      if (typeof kk.applyTriggerContent === 'function') {
        kk.applyTriggerContent(trigger);
      }
      if (typeof kk.open === 'function') {
        kk.open(true);
      }
      return true;
    }

    function init() {
      if (!document.querySelector('.badge-box--kommersnart')) return;

      var imageWrap = document.querySelector('.product__images');
      if (!imageWrap) return;
      if (imageWrap.querySelector('.kommer-snart-cta')) return;

      imageWrap.classList.add('product__images--kommersnart');

      var cta = document.createElement('div');
      cta.className = 'kommer-snart-cta';
      cta.innerHTML =
        '<a href="#" data-open-kundeklubb-popup class="kommer-snart-cta__btn">' +
          '<svg class="kommer-snart-cta__lock" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
            '<rect x="2" y="7" width="10" height="8" rx="1" stroke="currentColor" stroke-width="1.4"/>' +
            '<path d="M4 7V4.5a3 3 0 0 1 6 0V7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
          '</svg>' +
          '<span>Få tidlig tilgang</span>' +
        '</a>';
      imageWrap.appendChild(cta);

      // Bind click → open popup (matcher hero-seksjonens trigger-logikk)
      var btn = cta.querySelector('.kommer-snart-cta__btn');
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openKKPopup(btn);
      });

      // Posisjoner CTA horisontalt sentrert på bilde-området.
      // Vertikalt: 50% av viewport (fixed). Horisontalt: midten av imageWrap.
      function positionCTA() {
        var rect = imageWrap.getBoundingClientRect();
        var centerX = rect.left + rect.width / 2;
        cta.style.left = centerX + 'px';
      }
      positionCTA();
      var ctaTicking = false;
      function ctaScheduled(){
        if (ctaTicking) return;
        ctaTicking = true;
        requestAnimationFrame(function(){ positionCTA(); ctaTicking = false; });
      }
      window.addEventListener('resize', ctaScheduled);
      window.addEventListener('scroll', ctaScheduled, { passive: true });

      // Fade inn/ut når bilde-området er i viewport
      if (typeof IntersectionObserver !== 'undefined') {
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(e) {
            cta.classList.toggle('is-visible', e.isIntersecting);
          });
        }, { threshold: 0.15 });
        io.observe(imageWrap);
      } else {
        cta.classList.add('is-visible');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  /* ----------------------------------------------------------
     PDP AUTOPLAY-VIDEO — hard-enforce autoplay + skjul kontroller
     ----------------------------------------------------------
     media_tag genererer <video> med autoplay/muted/loop, men noen
     browsere ignorerer autoplay til vi setter attrs eksplisitt på
     elementet etter mount. Vi legger også på controlsList +
     disablePictureInPicture for å skjule download/PiP-knapper, og
     fjerner controls-attributtet hvis det skulle slippe igjennom.
  ---------------------------------------------------------- */
  (function pdpAutoplayVideos() {
    function harden(video) {
      if (video.dataset.pdpAutoplayHardened) return;
      video.dataset.pdpAutoplayHardened = '1';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.removeAttribute('controls');
      video.controls = false;
      video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
      video.disablePictureInPicture = true;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function() {
          // Autoplay blocked — retry on first user interaction
          var retry = function() {
            video.play().catch(function(){});
            document.removeEventListener('touchstart', retry);
            document.removeEventListener('click', retry);
          };
          document.addEventListener('touchstart', retry, { once: true, passive: true });
          document.addEventListener('click', retry, { once: true });
        });
      }
    }

    function hardenAll() {
      document.querySelectorAll('video.pdp-video-autoplay, video.card-video-autoplay').forEach(harden);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hardenAll);
    } else {
      hardenAll();
    }
    document.addEventListener('shopify:section:load', hardenAll);

    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('video.pdp-video-autoplay, video.card-video-autoplay')) harden(n);
            if (n.querySelectorAll) {
              n.querySelectorAll('video.pdp-video-autoplay, video.card-video-autoplay').forEach(harden);
            }
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  })();

  // Re-sortér grid-items i Nyheter-context etter data-effective-ts (descending).
  // Bundles bruker nyeste komponentens created_at som effective_ts (satt i Liquid),
  // så bundles av gamle plagg synker ned blant gamle produkter selv om bundle-
  // produktet selv er nyopprettet.
  // Scope: /collections/nyheter (hele siden) + forsiden (KUN seksjon med
  // tittel "nyheter" — ikke bestselgere/andre).
  // FOUC-fix: skjuler grids med opacity 0 til sort er ferdig.
  (function sortNyheterByEffectiveDate() {
    var path = window.location.pathname || '';
    var isNyheterPage = path.indexOf('/collections/nyheter') === 0;
    var isHomepage = path === '/' || path === '' || path === '/no' || path === '/no/';
    if (!isNyheterPage && !isHomepage) return;
    var GRID_SELECTORS = ['#CollectionLoop', '.grid--mobile-slider', '.grid--slider', '.grid'];

    // Inject CSS for å skjule grids inntil JS har sortert ferdig
    var styleTag = document.createElement('style');
    styleTag.textContent = '[data-effective-sort-pending] { opacity: 0 !important; transition: none !important; }';
    document.head.appendChild(styleTag);
    // Marker grids som "pending" før første sort
    function markPending() {
      document.querySelectorAll(GRID_SELECTORS.join(',')).forEach(function (grid) {
        if (grid.querySelector(':scope > [data-effective-ts]')) {
          grid.setAttribute('data-effective-sort-pending', '');
        }
      });
    }
    if (document.readyState === 'loading') {
      // Run as early as possible
      markPending();
    } else {
      markPending();
    }
    var moNyheter;
    function isNyheterContext(grid) {
      // På /collections/nyheter — alle grids sorteres
      if (isNyheterPage) return true;
      // På forsiden — kun grids inne i seksjon med "nyheter" som heading
      var section = grid.closest('section, [data-section-type]');
      if (!section) return false;
      var heading = section.querySelector('.grid__heading, h1, h2, h3');
      if (!heading) return false;
      var text = (heading.textContent || '').trim().toLowerCase();
      return text === 'nyheter' || text === 'nye varer' || text === 'nyhet';
    }
    function reorder(grid) {
      if (!grid || !isNyheterContext(grid)) return false;
      var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > [data-effective-ts]'));
      if (items.length < 2) return false;
      var soldOut = [];
      var rest = [];
      items.forEach(function (el) {
        if (el.classList.contains('product-item--sold-out')) {
          soldOut.push(el);
        } else {
          rest.push(el);
        }
      });
      rest.sort(function (a, b) {
        return parseInt(b.dataset.effectiveTs, 10) - parseInt(a.dataset.effectiveTs, 10);
      });
      var sorted = rest.concat(soldOut);
      var changed = false;
      for (var i = 0; i < sorted.length; i++) {
        if (grid.children[i] !== sorted[i]) { changed = true; break; }
      }
      if (!changed) return false;
      sorted.forEach(function (el) { grid.appendChild(el); });
      // Trigger grid-slider re-init så slideren reflekterer ny rekkefølge.
      // <grid-slider> web component holder intern state om items'ene —
      // uten dette ser visuelt rekkefølgen ut som før sort.
      var slider = grid.closest('grid-slider');
      if (slider) {
        slider.dispatchEvent(new CustomEvent('theme:grid-slider:init', { bubbles: true }));
      }
      // Backup: trigger window resize som mange slidere lytter til
      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
      return true;
    }
    function reorderAll() {
      if (moNyheter) moNyheter.disconnect();
      try {
        document.querySelectorAll(GRID_SELECTORS.join(',')).forEach(function (grid) {
          reorder(grid);
          // Avslør grid etter sort uansett (også hvis sort ikke endret noe)
          grid.removeAttribute('data-effective-sort-pending');
        });
      } finally {
        if (moNyheter) moNyheter.observe(document.body, { childList: true, subtree: true });
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reorderAll);
    } else {
      reorderAll();
    }
    var debounce;
    moNyheter = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(reorderAll, 100);
    });
    moNyheter.observe(document.body, { childList: true, subtree: true });
  })();

  // Push utsolgte produkter nederst i alle kolleksjonslister.
  // Hook: .product-item--sold-out (satt i product-grid-item.liquid:635 når sold_out=true).
  // Skipper reorder hvis allerede riktig, og disconnecter observer under egen mutation
  // for å unngå infinite-loop som ville henge JS-tråden og blokkere klikk.
  (function pushSoldOutLast() {
    var GRID_SELECTORS = [
      '#CollectionLoop',
      '.grid--mobile-slider',
      '.grid--slider',
      '.grid'
    ];
    var mo;
    function isAlreadySorted(grid, soldOut) {
      var children = grid.children;
      var n = children.length;
      var s = soldOut.length;
      for (var i = 0; i < s; i++) {
        if (children[n - s + i] !== soldOut[i]) return false;
      }
      return true;
    }
    function reorder(grid) {
      if (!grid) return false;
      var soldOut = grid.querySelectorAll(':scope > .product-item--sold-out');
      if (soldOut.length === 0) return false;
      if (isAlreadySorted(grid, soldOut)) return false;
      soldOut.forEach(function (el) { grid.appendChild(el); });
      return true;
    }
    function reorderAll() {
      if (mo) mo.disconnect();
      try {
        document.querySelectorAll(GRID_SELECTORS.join(',')).forEach(reorder);
      } finally {
        if (mo) mo.observe(document.body, { childList: true, subtree: true });
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reorderAll);
    } else {
      reorderAll();
    }
    var debounce;
    mo = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(reorderAll, 100);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  })();

  /* ------------------------------------------------------------------
     STØRRELSE-accordion → trigge size guide popup
     "Åpne size guide"-link i accordion klikker den eksisterende
     size-guide popup-triggeren som er bundet til popup-component.
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href="#size-guide"], [data-open-size-guide]');
    if (!link) return;
    e.preventDefault();
    var trigger = document.querySelector('.radio__legend__link[data-popup-open]')
      || document.querySelector('a[data-popup-open]');
    if (trigger) trigger.click();
  });

  /* ------------------------------------------------------------------
     PDP video — autoplay muted/loop, fjern native controls, injiser
     subtil play/pause-toggle i hjørnet.
     ------------------------------------------------------------------ */
  function enhancePdpVideos() {
    var videos = document.querySelectorAll(
      '.product__photo--video video, .product__media video.media-video, video.pdp-video-autoplay'
    );
    videos.forEach(function (video) {
      if (video.dataset.pdpEnhanced) return;
      video.dataset.pdpEnhanced = '1';
      video.removeAttribute('controls');
      video.muted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('muted', '');
      video.play().catch(function () {});

      var wrap = video.parentElement;
      if (!wrap || wrap.querySelector('.pdp-video-toggle')) return;
      if (getComputedStyle(wrap).position === 'static') {
        wrap.style.position = 'relative';
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pdp-video-toggle';
      btn.setAttribute('aria-label', 'Spill av eller pause video');
      btn.innerHTML =
        '<svg class="pdp-video-toggle__icon pdp-video-toggle__icon--play" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>' +
        '<svg class="pdp-video-toggle__icon pdp-video-toggle__icon--pause" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg>';
      btn.dataset.state = video.paused ? 'paused' : 'playing';
      wrap.appendChild(btn);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (video.paused) video.play();
        else video.pause();
      });
      video.addEventListener('play', function () {
        btn.dataset.state = 'playing';
      });
      video.addEventListener('pause', function () {
        btn.dataset.state = 'paused';
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhancePdpVideos);
  } else {
    enhancePdpVideos();
  }
  new MutationObserver(function () {
    enhancePdpVideos();
  }).observe(document.body, { childList: true, subtree: true });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
